<template>
    <div>
        <div class="box">
            <div class="text">
                <h3 class="text-title reveal-bottom">
                    {{ $t("sd.w1") }}<br />OBC SD-WAN
                </h3>
                <div class="text-cont reveal-bottom">
                    {{ $t("sd.wc") }}
                </div>
            </div>
            <img class="bg" :src="bg" alt="bg" />
        </div>
        <div :style="{ backgroundImage: 'url(' + bg1 + ')' }" class="wrap">
            <div class="box">
                <div class="content">
                    <h3 class="text-title reveal-bottom">{{ $t("sd.mt") }}</h3>
                    <div
                        class="text-cont reveal-bottom"
                        style="margin-top:40px;width:578px;"
                    >
                        {{ $t("sd.mc") }}
                    </div>
                    <div class="reveal-bottom">
                        <img
                            class="img1"
                            :src="
                                require('@/assets/img_svg/technology-1-SD-WAN-img-2.svg')
                            "
                            alt="svg"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="big-title99">
            <div>{{ $t("sd.tt") }}</div>
        </div>
        <div
            :style="{ backgroundImage: 'url(' + bg2 + ')' }"
            class="wrap wrap1"
        >
            <div class="box">
                <div class="content content1">
                    <h3 class="text-title reveal-bottom">SD-WAN</h3>
                    <div
                        class="text-cont reveal-bottom"
                        style="margin-top:40px;width:506px;"
                    >
                        {{ $t("sd.sdc") }}
                    </div>
                    <div class="reveal-bottom">
                        <img
                            class="img1"
                            :src="
                                require('@/assets/img_svg/technology-1-SD-WAN-img-4.svg')
                            "
                            alt="svg"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="content3">
            <div class="text-title  reveal-bottom">
                {{ $t("sd.ut") }}
            </div>
            <div>
                <img
                    class="img2"
                    :src="
                        lang === 'en_US'
                            ? require('@/assets/img_svg/technology-1-SD-WAN-img-6-en.png')
                            : require('@/assets/img_svg/technology-1-SD-WAN-img-6-cn.png')
                    "
                    alt="svg"
                />
            </div>
        </div>
        <div class="content4">
            <div class="center">
                <div class="c4-title reveal-bottom">{{ $t("sd.w2") }}</div>
                <div class="c4-text reveal-bottom">
                    {{ $t("sd.w2c") }}
                </div>
                <div class="c4-wrap">
                    <div class="c4-item reveal-bottom">
                        <div class="c4-item-wrap">
                            <div class="c4-item-top">
                                {{ $t("sd.c1c") }}
                            </div>
                            <div class="c4-item-bottom">
                                <img
                                    class="c4-item-icon"
                                    :src="
                                        require('@/assets/img_svg/sdwan0.svg')
                                    "
                                    alt="svg"
                                />
                                <div class="c4-item-text">
                                    {{ $t("sd.c1") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c4-item reveal-bottom">
                        <div class="c4-item-wrap">
                            <div class="c4-item-top">
                                {{ $t("sd.c2c") }}<br />
                                {{ $t("sd.c2c1") }}
                            </div>
                            <div class="c4-item-bottom">
                                <img
                                    class="c4-item-icon"
                                    :src="
                                        require('@/assets/img_svg/sdwan1.svg')
                                    "
                                    alt="svg"
                                />
                                <div class="c4-item-text">
                                    {{ $t("sd.c2") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c4-item reveal-bottom">
                        <div class="c4-item-wrap">
                            <div class="c4-item-top">
                                {{ $t("sd.c3c") }}
                            </div>
                            <div class="c4-item-bottom">
                                <img
                                    class="c4-item-icon"
                                    :src="
                                        require('@/assets/img_svg/sdwan2.svg')
                                    "
                                    alt="svg"
                                />
                                <div class="c4-item-text">
                                    {{ $t("sd.c3") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c4-item reveal-bottom">
                        <div class="c4-item-wrap">
                            <div class="c4-item-top">
                                {{ $t("sd.c4c") }}<br />
                                {{ $t("sd.c4c1") }}
                            </div>
                            <div class="c4-item-bottom">
                                <img
                                    class="c4-item-icon"
                                    :src="
                                        require('@/assets/img_svg/sdwan3.svg')
                                    "
                                    alt="svg"
                                />
                                <div class="c4-item-text">
                                    {{ $t("sd.c4") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c4-item reveal-bottom">
                        <div class="c4-item-wrap">
                            <div class="c4-item-top">
                                {{ $t("sd.c5c") }}
                            </div>
                            <div class="c4-item-bottom">
                                <img
                                    class="c4-item-icon"
                                    :src="
                                        require('@/assets/img_svg/sdwan4.svg')
                                    "
                                    alt="svg"
                                />
                                <div class="c4-item-text">
                                    {{ $t("sd.c5") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c4-item reveal-bottom">
                        <div class="c4-item-wrap">
                            <div class="c4-item-top">
                                {{ $t("sd.c6c") }}
                            </div>
                            <div class="c4-item-bottom">
                                <img
                                    class="c4-item-icon"
                                    :src="
                                        require('@/assets/img_svg/sdwan5.svg')
                                    "
                                    alt="svg"
                                />
                                <div class="c4-item-text">
                                    {{ $t("sd.c6") }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import initAnimation from "../animation";
export default {
    data() {
        return {
            bg: require("@/assets/images/technology-1-SD-WAN-img-1.png"),
            bg1: require("@/assets/images/technology-1-SD-WAN-img-3.jpg"),
            bg2: require("@/assets/images/technology-1-SD-WAN-img-5.jpg"),
            lang: localStorage.getItem("lang"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
        this.$bus.$on("lang", (lang) => (this.lang = lang));
    },
};
</script>
<style scoped>
.box {
    width: 1200px;
    margin: auto;
    height: 947px;
    position: relative;
    padding: 0 10px;
    box-sizing: border-box;
}
.text {
    width: 465px;
    position: absolute;
    top: 285px;
    left: 0;
}
.text-title {
    font-size: 44px;
    color: #000000;
    letter-spacing: 0;
    line-height: 56px;
    font-weight: bold;
}
.text-cont {
    margin-top: 29px;
    font-size: 18px;
    color: #000000;
    line-height: 36px;
}
.bg {
    width: 745px;
    position: absolute;
    top: 200px;
    right: 0;
}
.wrap {
    width: 100%;
    height: 860px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left;
    background-attachment: fixed;
}
.wrap1 {
    background-position: right;
}
.box {
    width: 1200px;
    margin: auto;
    background-color: transparent;
}
.content {
    width: 618px;
    float: right;
    background-color: transparent;
    margin-top: 40px;
}
.content1 {
    float: left;
}
.img {
    width: 618px;
    height: 235px;
    margin-top: 72px;
}
.img1 {
    width: 618px;
    height: 340px;
    margin-top: 53px;
}
.big-title99 {
    width: 1180px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 512px;
}
.big-title99 > div {
    width: 1180px;
    line-height: 89px;
    font-size: 72px;
    color: #00a3d1;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
}

.img2 {
    width: 1200px;
    height: 826px;
}
.content3 {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 140px 0;
    position: relative;
}

.content4 {
    height: 1027px;
    background: #00a3d1;
    overflow: hidden;
}
.c4-title {
    font-size: 44px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: bold;
    line-height: 66px;
    margin-top: 120px;
}
.c4-text {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 36px;
    width: 578px;
}
.center {
    width: 1200px;
    margin: auto;
}
.c4-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    height: 494px;
    margin-top: 65px;
}
.c4-item {
    width: 391px;
    height: 240.5px;
    overflow: hidden;
}
.c4-item-top {
    width: 391px;
    height: 240.5px;
    box-sizing: border-box;
    padding: 43px 30px;
    background: #312f38;
    font-size: 18px;
    color: #ffffff;
    line-height: 30px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: all 0.5s ease;
}
.c4-item-bottom {
    width: 391px;
    height: 240.5px;
    display: flex;
    background: #fff;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 1;
    transition: all 0.5s ease;
}

.c4-item-text {
    text-align: center;
    font-size: 16px;
    color: #333333;
    text-align: center;
    line-height: 22px;
    margin-top: 28px;
}
.c4-item-wrap {
    /* transform: translateY(-240.5px); */
    /* transition: transform 0.3s linear; */
    position: relative;
}
.c4-item-icon {
    width: 72px;
    height: 65px;
    margin: 0 auto;
}
.c4-item-wrap:hover .c4-item-top {
    opacity: 1;
    transition: all 0.5s ease;
    /* transform: translateY(0); */
}
.c4-item-wrap:hover .c4-item-bottom {
    opacity: 0;
    transition: all 0.5s ease;
    /* transform: translateY(0); */
}
</style>



// WEBPACK FOOTER //
// src/Pages/SD-WAN/SD-WAN.vue